import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CoreModule } from './../core/core.module';
import { TrialGuardService } from '../core';
import {
  CustomerBaseComponent,
  CustomerComponent,
  CustomersComponent,
  CustomerSalesRepsComponent,
  CustomerDashboardComponent,
  CustomerProductTypesComponent,
  CustomerService,
  SelectedCustomerService,
  CustomerSalesRepService,
} from '../customer';
import { ProductTypeTransactionsComponent } from '../equipment';
import { SavedViewsModule } from '@/app/modules/saved-views/saved-views.module';
import { SavedViewsComponent } from '@/app/modules/saved-views/saved-views/saved-views.component';
import { LogService } from '@/app/core/services/log.service';
import { CollapsibleComponent } from '@/app/equipment/components/collapsible.component';
import { CollapsibleButtonComponent } from '@/app/equipment/components/collapsible-button.component';
import { CollapsedCardsDirective } from '@/app/equipment/components/collapsed-cards.directive';
import { FeatureFlagModule } from '@/app/core/feature-flags/feature-flag.module';

const root = 'customers';
const customerRoutes: Routes = [
  {
    path: root,
    component: CustomersComponent,
    data: { title: 'main.tabs.customers.page_titles.root' },
    canActivate: [TrialGuardService],
  },
  {
    path: root + '/:customer',
    component: CustomerComponent,
    canActivate: [TrialGuardService],
    children: [
      {
        path: '',
        component: CustomerDashboardComponent,
        data: {
          name: 'dashboard',
          title: 'main.tabs.customers.page_titles.dashboard',
        },
      },
      {
        path: 'sales-reps',
        component: CustomerSalesRepsComponent,
        data: {
          name: 'sales-reps',
          title: 'main.tabs.customers.page_titles.sales_reps',
        },
      },
      {
        path: 'product-types',
        component: CustomerProductTypesComponent,
        data: {
          name: 'product-types',
          title: 'main.tabs.customers.page_titles.product_types',
        },
      },
      {
        path: 'transactions',
        component: ProductTypeTransactionsComponent,
        data: {
          title: 'main.tabs.customers.page_titles.transactions',
        },
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(customerRoutes),
    CommonModule,
    CoreModule,
    InfiniteScrollModule,
    SavedViewsModule,
    SavedViewsComponent,
    FeatureFlagModule,
    CollapsibleComponent,
    CollapsibleButtonComponent,
    CollapsedCardsDirective,
  ],
  providers: [
    CustomerService,
    SelectedCustomerService,
    CustomerSalesRepService,
    TrialGuardService,
    LogService,
  ],
  declarations: [
    CustomerBaseComponent,
    CustomerComponent,
    CustomersComponent,
    CustomerDashboardComponent,
    CustomerSalesRepsComponent,
    CustomerProductTypesComponent,
  ],
})
export class CustomerModule {}
